import { useInfiniteQuery } from "@tanstack/react-query";

import {
  getNotificationsByAccount,
  getNotificationsByUser,
} from "@/api/graphql/notifications/api.ts";
import {
  createGetNotificationsByAccountQueryOptions,
  createGetNotificationsByUserQueryOptions,
} from "@/api/graphql/notifications/queryOptions.ts";
import {
  GetNotificationsByAccount,
  GetNotificationsByUser,
} from "@/api/graphql/notifications/types.ts";

export const useGetNotificationsByUser = ({
  pageSize,
  userId,
}: GetNotificationsByUser) => {
  const response = useInfiniteQuery(
    createGetNotificationsByUserQueryOptions(
      { pageSize, userId },
      getNotificationsByUser,
    ),
  );

  return {
    ...response,
    totalNotifications: response.data?.pages[0]?.pagination.total || 0,
  };
};

export const useGetNotificationsByAccount = ({
  pageSize,
  accountId,
}: GetNotificationsByAccount) => {
  const response = useInfiniteQuery(
    createGetNotificationsByAccountQueryOptions(
      { pageSize, accountId },
      getNotificationsByAccount,
    ),
  );

  return {
    ...response,
    totalNotifications: response.data?.pages[0]?.pagination.total || 0,
  };
};
